import { InitialState, StoreLoadingEnum } from 'src/store/state/types';
import { IFilesSpec } from './types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import fileSpecApi from './api';
import { RootState } from '../..';

/**
 * Initial State
 */

const initialState: InitialState<IFilesSpec> = {
  loading: StoreLoadingEnum.idle,
  error: null,
  data: {
    items: [],
  },
};

/**
 * Async Actions
 */

export const fetchFileSpec = createAsyncThunk('fileSpec', async () => {
  try {
    const response = await fileSpecApi.fetchFileSpec();
    return { data: { ...response.data } };
  } catch (e) {
    console.error(e);
  }
});

export const fileSpecSlice = createSlice({
  name: 'fileSpec',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFileSpec.pending, (state) => {
        state.loading = StoreLoadingEnum.pending;
      })
      .addCase(fetchFileSpec.fulfilled, (state, action) => {
        state.loading = StoreLoadingEnum.succeeded;
        const { data } = action.payload!;
        state.data = data;
      })
      .addCase(fetchFileSpec.rejected, (state) => {
        state.loading = StoreLoadingEnum.failed;
      });
  },
});

export const fileSpecSelector = (state: RootState) => state.fileSpec.data;
export const isLoadingSelector = (state: RootState) =>
  state.fileSpec.loading === StoreLoadingEnum.pending;
